import { VerticalContainer } from '@american-autonomy/ag-ui';

import FormErrorText from 'components/text/FormErrorText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FormErrors: FunctionComponent<Props> = ({ errors, testId = TEST_ID }) => {
    const { PLEASE_CORRECT_THE_FOLLOWING } = useTranslation();

    const flattenedErrors = errors
        ? Object.values(errors).flatMap(error => {
              if (error?.message) {
                  return [error];
              }

              if (error && typeof error === 'object') {
                  return Object.values(error).filter(nestedError => nestedError?.message);
              }

              return [];
          })
        : [];

    return (
        <VerticalContainer className={styles.formErrors} testId={testId}>
            <FormErrorText text={PLEASE_CORRECT_THE_FOLLOWING} />

            {flattenedErrors.map((error, index) => (
                <FormErrorText key={index} text={error?.message as string} />
            ))}
        </VerticalContainer>
    );
};

export default FormErrors;
